import React from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';

import BasePage from '../Base';
import { TotalEmissionsByScopePieChartDataType } from './types';
import PDFChart from '../../../components/PDFChart';

// need to use Stylesheets since react-pdf is not supporting classNames or styled-components
const styles = StyleSheet.create({
  chart: { margin: '230px 100px 0px 0px' },
});

type TotalEmissionsByScopePieChartProps = {
  data: {
    total_emissions_by_scope_pie_chart: TotalEmissionsByScopePieChartDataType;
  };
};

const TotalEmissionsByScopePieChart = ({
  data,
}: TotalEmissionsByScopePieChartProps) => {
  const {
    chart,
    page_title: pageTitle,
    top_right: topRight,
  } = data.total_emissions_by_scope_pie_chart;
  return (
    <BasePage
      backgroundImageName="Report_envirly_slide_8.png"
      mainHeader={pageTitle}
      topRight={topRight}
    >
      <View>
        <PDFChart base64={chart} style={styles.chart} />
      </View>
    </BasePage>
  );
};

export default TotalEmissionsByScopePieChart;
